import { createActionRoute, createSiteRoute } from '@townsquare/router/create-route';

export const reactionUpdateActionRoute = createSiteRoute(
  createActionRoute({
    exact: true,
    name: 'reactionAction',
    path: '/update/:id/reaction',
  }),
);
